var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-wrapper" },
    [
      _c(
        "div",
        { staticClass: "sidebar-logo-container" },
        [
          _c(
            "router-link",
            { staticClass: "sidebar-logo-link", attrs: { to: "/" } },
            [
              _c("span", { staticClass: "sidebar-logo" }, [_vm._v("🏠")]),
              _vm._v(" "),
              !_vm.isCollapse
                ? _c("span", { staticClass: "sidebar-title" }, [
                    _vm._v("家邻后台"),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "show-timeout": 200,
                "default-active": _vm.$route.path,
                collapse: _vm.isCollapse,
                "collapse-transition": false,
                mode: "vertical",
                "background-color": _vm.menuBg,
                "text-color": _vm.menuText,
                "active-text-color": _vm.menuActiveText,
              },
            },
            _vm._l(_vm.permission_routers, function (route) {
              return _c("sidebar-item", {
                key: route.path,
                attrs: { item: route, "base-path": route.path },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }